// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ph-0";